var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 4.16667C10.7339 4.16667 11.6667 3.23393 11.6667 2.08333C11.6667 0.93274 10.7339 0 9.58333 0C8.43274 0 7.5 0.93274 7.5 2.08333C7.5 3.23393 8.43274 4.16667 9.58333 4.16667Z",
    fill: "url(#paint0_linear_192_475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33333C19.2538 3.33333 20 2.58714 20 1.66667C20 0.746192 19.2538 0 18.3333 0C17.4128 0 16.6666 0.746192 16.6666 1.66667C16.6666 2.58714 17.4128 3.33333 18.3333 3.33333Z",
    fill: "url(#paint1_linear_192_475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6191 4.17333L10.7683 5H8.21247L5.0008 3.39417V1.25C5.0008 0.559167 4.44163 0 3.7508 0C3.05997 0 2.5008 0.559167 2.5008 1.25V3.65167C2.5008 4.44583 2.94163 5.16 3.65247 5.515L6.66747 7.0225V11.6825L5.13163 13.8333C5.0808 13.905 5.00913 13.9575 4.92413 13.9858L1.6883 15.0642C1.0333 15.2825 0.679967 15.99 0.898301 16.645C1.11497 17.3058 1.84163 17.6533 2.47913 17.435L5.71413 16.3567C6.30413 16.1608 6.8058 15.7892 7.1658 15.285L9.16663 12.5442V14.9458L6.55913 17.9258C6.10497 18.4458 6.15747 19.235 6.67663 19.69C7.19413 20.1433 7.98413 20.0933 8.4408 19.5725L11.15 16.4758C11.4825 16.0958 11.6666 15.6083 11.6666 15.1033V7.41917L18.8808 6.66C19.5675 6.58833 20.065 5.9725 19.9925 5.28583C19.9208 4.59917 19.3108 4.1 18.6183 4.17417L18.6191 4.17333Z",
    fill: "url(#paint2_linear_192_475)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_475",
    x1: 9.58333,
    y1: 0,
    x2: 9.58333,
    y2: 4.16667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_192_475",
    x1: 18.3333,
    y1: 0,
    x2: 18.3333,
    y2: 3.33333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_192_475",
    x1: 10.4166,
    y1: 0,
    x2: 10.4166,
    y2: 19.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.5d8131f8e308d6a4aaaadff47883f75e.svg";
export { ForwardRef as ReactComponent };